import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

// Attach bearer token (fallback for cross-site cookie edge cases)
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem("tb_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch (e) {
    /* noop */
  }
  return config;
});

export function saveToken(t) {
  try {
    if (t) localStorage.setItem("tb_token", t);
    else localStorage.removeItem("tb_token");
  } catch (e) {
    /* noop */
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
